const SAVE_AUTH_USER_SUCCESS = 'RC_SAVE_AUTH_USER_SUCCESS'
const SAVE_AUTH_USER_FAILURE = 'RC_SAVE_AUTH_USER_FAILURE'
const REMOVE_AUTH_USER = 'RC_REMOVE_AUTH_USER'

export default {
  SAVE_AUTH_USER_SUCCESS,
  SAVE_AUTH_USER_FAILURE,
  REMOVE_AUTH_USER,
}
